import { render, staticRenderFns } from "./GroupPaymentForm.vue?vue&type=template&id=b53a2158"
import script from "./GroupPaymentForm.vue?vue&type=script&lang=js"
export * from "./GroupPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports